<div class="grid">
  <div class="col-12">
<p-fieldset [legend]="'CONFIGURATION_COMPONENT.LOCALE_FRENCH' | translate">
  <div class="grid">
    <div class="col-3">
      <h3>{{ 'CONFIGURATION_COMPONENT.MESSAGE_LINE_1' | translate }}</h3>
    </div>
    <div class="col-9">
          <textarea rows="1" cols="50" pInputTextarea maxlength="150" [autoResize]="false"
                    [(ngModel)]="frMod.line1"></textarea>
    </div>
    <div class="col-3">
      <h3>{{ 'CONFIGURATION_COMPONENT.MESSAGE_LINE_2' | translate }}</h3>
    </div>
    <div class="col-9">
          <textarea rows="1" cols="50" pInputTextarea maxlength="150" [autoResize]="false"
                    [(ngModel)]="frMod.line2"></textarea>
    </div>
    <div class="col-3">
      <h3>{{ 'CONFIGURATION_COMPONENT.MESSAGE_LINE_3' | translate }}</h3>
    </div>
    <div class="col-9">
          <textarea rows="1" cols="50" pInputTextarea maxlength="150" [autoResize]="false"
                    [(ngModel)]="frMod.line3"></textarea>
    </div>
  </div>
</p-fieldset>
<div class="empty-div"></div>
<p-fieldset [legend]="'CONFIGURATION_COMPONENT.LOCALE_ENGLISH' | translate">
  <div class="grid">
    <div class="col-3">
      <h3>{{ 'CONFIGURATION_COMPONENT.MESSAGE_LINE_1' | translate }}</h3>
    </div>
    <div class="col-9">
          <textarea rows="1" cols="50" pInputTextarea maxlength="150" [autoResize]="false"
                    [(ngModel)]="enMod.line1"></textarea>
    </div>
    <div class="col-3"><h3>{{ 'CONFIGURATION_COMPONENT.MESSAGE_LINE_2' | translate }}</h3>
    </div>
    <div class="col-9">
          <textarea rows="1" cols="50" pInputTextarea maxlength="150" [autoResize]="false"
                    [(ngModel)]="enMod.line2"></textarea>
    </div>
    <div class="col-3">
      <h3>{{ 'CONFIGURATION_COMPONENT.MESSAGE_LINE_3' | translate }}</h3>
    </div>
    <div class="col-9">
          <textarea rows="1" cols="50" pInputTextarea maxlength="150" [autoResize]="false"
                    [(ngModel)]="enMod.line3"></textarea>
    </div>
  </div>
</p-fieldset>
  </div>
  <div class="col-6">
    <button pButton type="button" (click)="deleteMessage()"
            [label]="'CONFIGURATION_COMPONENT.RESET_MOD_BTN' | translate" class="p-button-danger align-left"></button>
  </div>
  <div class="col-6">
    <button pButton type="button" (click)="saveMessage()"
            [label]="'CONFIGURATION_COMPONENT.SAVE_MOD_BTN' | translate"
            class="save-btn p-button-success"></button>
  </div>
</div>
